export enum AxiomaW1AlarmCode {
  /**
   * Occurs approx. 30 seconds after the absence of water.
   * Disappears immediately (up to 30 seconds) if meter detects water without air or air bubbles.
   */
  EMPTY_PIPE = 'emptyPipe',

  /**
   * Occurs when meter detects negative flow that is equal to 2 x starting flow.
   * Disappears immediately if reverse flow is stopped.
   */
  REVERSE_FLOW = 'reverseFlow',

  /**
   * Occurs when flow rate is higher than Q4.
   */
  OVERFLOW = 'overflow',

  /**
   * Occurs when water temperature is lower than 2/3/4/5°C for 5 minutes.
   * Disappears after 5 minutes, if water temperature is higher than configured value.
   */
  FREEZE_ALERT = 'freezeAlert',

  /**
   * Occurs when a software failure is detected in the meter.
   */
  SOFTWARE_FAILURE_DETECTED = 'softwareFailureDetected',

  /**
   * Occurs when a hardware failure is detected in the meter.
   */
  HARDWARE_FAILURE_DETECTED = 'hardwareFailureDetected',

  /**
   * Occurs when constant flow rate within 24 hours is more than 0.25/0.5/1% of Q3.
   * Disappears after 1 hour, if constant flow rate within that hour is less than configured value.
   */
  LEAKAGE = 'leakage',

  /**
   * Occurs when constant flow rate within 60 minutes is more than 5/10/20% of Q3.
   * Disappears after 32 seconds, if constant flow rate within that period of time is less than configured value.
   */
  BURST = 'burst',

  /**
   * Only on meter's LCD.
   */
  COMMUNICATION_TEMPORARILY_BLOCKED = 'communicationTemporarilyBlocked',

  /**
   * Occurs when approx. battery lifetime is less than 12 months.
   */
  LOW_BATTERY = 'lowBattery',

  /**
   * Occurs when there was no water usage for the last 3/7/30 days.
   */
  NO_CONSUMPTION = 'noConsumption',

  /**
   * Occurs when the meter housing is damaged.
   */
  DAMAGE_TO_METER_HOUSING = 'damageToMeterHousing',

  /**
   * Occurs when a calculator hardware failure is detected.
   */
  CALCULATOR_HARDWARE_FAILURE = 'calculatorHardwareFailure'
}
